import ForgotPasswordCard from '../components/ForgotPasswordCard';

export default function ForgotPassword() {
  return (
    <div className="min-w-screen min-h-screen bg-[#F9F5F2]">
      <div className="w-full flex justify-center py-16 px-4">
        <ForgotPasswordCard />
      </div>
    </div>
  );
}

